<template>
  <div class="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
    <div class="glass-strong rounded-xl p-6 w-full max-w-md mx-4">
      <h3 class="text-xl font-bold text-white mb-2">What would you like to do?</h3>
      <p class="text-slate-400 text-sm mb-4">
        {{ make }} • {{ model }} — <span class="font-mono">{{ serial }}</span>
      </p>
      <div class="grid grid-cols-1 gap-3">
        <button
          class="px-4 py-2 rounded-lg bg-amber-600 text-white hover:bg-amber-500"
          @click="$emit('reserve')"
        >
          Reserve
        </button>
        <button
          class="px-4 py-2 rounded-lg bg-primary-600 text-white hover:bg-primary-500"
          @click="$emit('checkout')"
        >
          Check Out
        </button>
        <button
          class="px-4 py-2 rounded-lg bg-yellow-600 text-white hover:bg-yellow-500"
          @click="$emit('maintenance')"
        >
          Maintenance
        </button>
        <button
          class="px-4 py-2 rounded-lg bg-slate-800 border border-slate-700 text-white"
          @click="$emit('close')"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ make: string; model: string; serial: string }>()
defineEmits(['reserve', 'checkout', 'maintenance', 'close'])
</script>

<style scoped></style>
